"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quantityValidatorCreator = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const FormValidatorDecoratorService_1 = require("./FormValidatorDecoratorService");
class _QuantityValidatorCreator {
    /**
     * Creates a quantity threshold validator.
     *
     * @param options Options:
     * unitSystem The unit system that should be used.
     * metricValidator Localized threshold validator for the metric unit system.
     * metricUnit Metric unit that should be used for the quantity.
     * imperialValidator Localized threshold validator for the imperial unit system.
     * imperialUnit Imperial unit that should be used for the quantity.
     */
    createQuantityThresholdValidator(options) {
        let validator;
        let unit;
        if (options.unitSystem === echain_shared_i18n_1.UnitSystem.imperial) {
            validator = options.imperialValidator;
            unit = options.imperialUnit;
        }
        else {
            validator = options.metricValidator;
            unit = options.metricUnit;
        }
        return this.createQuantityThresholdValidatorFromValidator({
            unitSystem: options.unitSystem,
            unit,
            validator,
        });
    }
    /**
     * Creates a quantity threshold validator.
     *
     * @param options Options:
     * unitSystem The unit system that is used.
     * unit The unit of the quantity.
     * validator The localized threshold validator function that should be converted to a quantity threshold validator.
     */
    createQuantityThresholdValidatorFromValidator(options) {
        return FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToQuantityThresholdValidator(options.validator, {
            unitSystem: options.unitSystem,
            unit: options.unit,
        });
    }
    /**
     * Creates a quantity range validator.
     *
     * @param options Options:
     * unitSystem The unit system that should be used.
     * metricValidator Localized range validator for the metric unit system.
     * metricUnit Metric unit that should be used for the quantity.
     * imperialValidator Localized range validator for the imperial unit system.
     * imperialUnit Imperial unit that should be used for the quantity.
     */
    createQuantityRangeValidator(options) {
        let validator;
        let unit;
        if (options.unitSystem === echain_shared_i18n_1.UnitSystem.imperial) {
            validator = options.imperialValidator;
            unit = options.imperialUnit;
        }
        else {
            validator = options.metricValidator;
            unit = options.metricUnit;
        }
        return this.createQuantityRangeValidatorFromValidator({
            unitSystem: options.unitSystem,
            unit,
            validator,
        });
    }
    /**
     * Creates a quantity range validator.
     *
     * @param options Options:
     * unitSystem The unit system that is used.
     * unit The unit of the quantity.
     * validator The localized range validator function that should be converted to a quantity range validator.
     */
    createQuantityRangeValidatorFromValidator(options) {
        return FormValidatorDecoratorService_1.formValidatorDecoratorService.extendToQuantityRangeValidator(options.validator, {
            unitSystem: options.unitSystem,
            unit: options.unit,
        });
    }
}
/**
 * Quantity validator creator singleton.
 */
exports.quantityValidatorCreator = new _QuantityValidatorCreator();
//# sourceMappingURL=QuantityValidatorCreator.js.map